import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCctvLine,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { publicFireBanner, rtlsSystem } from '@assets/images/solution';
import { publicFire1, publicFire2, recommendationServer } from '@assets/images/solution/recommendation';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicFire/img/1.avif';
import image2 from '@src/assets/images/solution/publicFire/img/2.avif';
import image3 from '@src/assets/images/solution/publicFire/img/3.avif';
import image4 from '@src/assets/images/solution/publicFire/img/4.avif';

import customer1 from '@src/assets/images/solution/publicFire/img/customer1.avif';
import function1 from '@src/assets/images/solution/publicFire/img/function1.avif';
import function2 from '@src/assets/images/solution/publicFire/img/function2.avif';
import function3 from '@src/assets/images/solution/publicFire/img/function3.avif';
import function4 from '@src/assets/images/solution/publicFire/img/function4.avif';
import recommendation from '../common/recommendation';

export default {
  type: '소방 솔루션',

  banner: {
    title: '소방학교 훈련 성과를 데이터 기반으로 정확히 검증하세요',
    desc: '위치추적 기술로 훈련자의 이동 경로와 체류 시간을 기록하고 훈련 리포트를 자동으로 생성합니다',
  },

  recommend: {
    title: '훈련자에게 태그를 부착해 이동 경로를 실시간 추적하고 3D 맵으로 시각화합니다',
    desc: '복잡한 훈련장 내에 설치된 수신기와 훈련자 태그가 연동되어, 이동 궤적이 실시간 수집되고 3D 맵 위에서 반복 진입 구간과 정체 지점을 분석합니다',
    labels: {
      desktop: [
        {
          img: publicFire1,
          data: recommendation.twintarckerUWB,
        },
        {
          img: publicFire2,
          data: recommendation.uwbTag,
        },
        {
          img: recommendationServer,
          data: recommendation.server,
        },
      ],
      mobile: [
        {
          data: recommendation.uwbTag,
        },
        {
          data: recommendation.twintarckerUWB,
        },
        {
          data: recommendation.server,
        },
        {
          data: recommendation.switch,
        },
      ],
    },
  },
  summary: {
    title: '소방 훈련의 정확한 평가와 운영을 디지털화하세요.',
    desc: '소방대원의 실시간 위치 데이터를 기반으로 훈련 과정과 성과를 객관적으로 분석하고 효율적으로 관리합니다.',
    function: {
      card: [
        {
          image: function1,
          title: '이동 경로 히트맵 시각화',
          desc: '소방대원의 구체적인 이동 경로와 동선을 데이터로 정밀하게 기록하여 훈련 목표 달성 여부를 평가합니다. 실제 이동 데이터를 기반으로 훈련 운영의 정확성을 분석하고 개선점을 명확히 도출합니다.',
        },
        {
          image: function2,
          title: '상세 이동 경로 데이터 분석',
          desc: '소방대원의 구체적인 이동 경로와 동선을 데이터로 정밀하게 기록하여 훈련 목표 달성 여부를 평가합니다. 실제 이동 데이터를 기반으로 훈련 운영의 정확성을 분석하고 개선점을 명확히 도출합니다.',
        },
        {
          image: function3,
          title: '정밀한 위치 데이터 수신 정확도 확보',
          desc: '트윈트래커를 통해 소방대원의 위치 데이터를 실시간으로 오차 없이 수신하고 기록하여, 훈련 과정에서의 정확한 이동 경로와 위치 분석이 가능합니다. 정밀한 데이터 수신으로 훈련 평가의 신뢰성을 높이고 효과적인 운영 관리를 지원합니다.',
        },
        {
          image: function4,
          title: '실시간 운영 현황 통합 관제',
          desc: '현장에 설치된 트윈트래커를 통해 전체 공간의 훈련 현황을 실시간으로 통합 관리하고, 훈련 진행 상태를 신속히 파악하여 운영의 효율성과 대응 속도를 높입니다.',
        },
      ],
    },
  },

  numOfCard: {
    title: '데이터 기반 소방 훈련 평가로 운영 효율을 극대화하세요',
    desc: '객관적인 훈련 데이터로 현장 운영을 정확하고 효과적으로 개선하세요.',
    card: [
      {
        tag: '97%',
        title: '훈련 이동 경로 자동 기록 정확도',
        desc: '훈련 중 소방대원의 이동 경로와 위치를 실시간으로 정확하게 기록하여 훈련 평가의 신뢰성을 극대화합니다.',
      },
      {
        tag: '95%',
        title: '실시간 위치추적 및 관제 커버리지',
        desc: '훈련 시설 내 모든 구역과 인원을 빠짐없이 커버하여 운영 상황을 완벽히 실시간 모니터링할 수 있습니다.',
      },
      {
        tag: '99%',
        title: '현장과 디지털 맵 구조 일치율',
        desc: '현장 구조를 디지털 맵에 정확히 구현하여 실제 훈련 현장과의 완벽한 일치성을 제공합니다.',
      },
    ],
  },

  func: [
    {
      theme: '소방대원 위치추적 기능을 활용하여<br/>훈련 정확성을 높이세요.',
      title: '정밀한 위치추적을 위한 트윈트래커 현장 맞춤형 설치',
      desc: '소방 훈련장 내 지하철 차량, 계단, 통로 등 현장의 실제 구조를 분석하여 트윈트래커를 최적의 위치에 맞춤형으로 설치합니다. 각 현장 특성을 면밀히 고려한 배치와 효율적인 구성을 통해 소방대원의 위치를 오차 없이 정밀하게 추적할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '현장에 설치된 트윈트래커를 통한 정확한 데이터 수신',
      desc: '실제 훈련 현장에 설치된 트윈트래커는 지하철 내부와 복잡한 구조물 사이에서도 신호 간섭 없이 정확한 위치 데이터를 안정적으로 수신합니다. 트윈트래커의 높은 수신 정확도를 통해 소방대원의 실시간 위치 정보를 신뢰성 있게 제공합니다.',
      sub2: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub1: '빠른 데이터 연동',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '현장 구조 기반으로 구현된 디지털 위치추적 환경',
      desc: '훈련 현장의 실제 구조와 지하철 차량 등 세부 사항을 그대로 디지털 맵에 구현하여 소방대원의 움직임을 직관적으로 모니터링합니다. 현장의 구조와 장애물까지 정확히 반영하여 현장과 디지털 화면 간의 일치성을 높이고 정확한 위치 데이터를 실시간으로 확보합니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '실제 설치 도면부터 3D 구현까지, 일관된 위치추적 솔루션 구축',
      desc: '트윈트래커의 설치는 정확한 설계 도면을 기반으로 이루어지며, 실제 현장 사진을 통해 설치 상태를 명확히 확인할 수 있습니다. 이를 바탕으로 한 직관적인 모니터링 화면과 현실감 있는 3D 시각화 환경으로 이어져, 설치에서 운영까지 일관되고 명확한 위치추적 솔루션을 제공합니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  customer: {
    title: 'ORBRO를 선택한 고객들의 생생한 후기를 확인해 보세요',
    card: [
      {
        logo: customer1,
        desc: '지금까지 소방훈련은 주로 경험과 직관에 의존하여 평가하는 방식이었습니다. 이번에 도입한 ORBRO의 실시간 위치추적 시스템 덕분에 소방대원의 훈련 과정과 이동 경로를 정확히 파악할 수 있게 되었습니다. 특히 훈련 결과를 객관적인 데이터로 바로 확인할 수 있어 훈련 평가의 신뢰성과 효율성이 크게 높아졌습니다. 향후 현장 작전에도 큰 도움이 될 것으로 기대하고 있습니다.',
        name: '서울특별시 소방재난본부',
      },
    ],
  },
  subfunc: {
    title: '기능 요약',
    desc: '작업자의 안전을 보장하는 것은 효율성을 높이고 사고로 인한 손실을 줄입니다. 오브로는 건설 현장 작업자의 안전을 지키기 위해서 최적의 기능들을 구성하였습니다. 작업자가 위험 지역에 다가거나 사고가 발생했을 때, 또는 중장비가 가진 잠재적 위험상황을 포함하여 발생할 수 있는 안전사고에 적절히 대응하도록 시스템을 구축하였습니다.',

    data: [
      {
        icon: IconAnalytics, // 히트맵 → 데이터 시각화 및 분석 의미
        title: '이동경로 히트맵 시각화',
        desc: '소방대원의 이동 경로를 히트맵으로 시각화해 반복 진입, 정체 구간을 분석합니다.',
      },
      {
        icon: IconAnalytics, // 이동 데이터 분석 → 정밀 기록 분석
        title: '정밀 이동 데이터 분석',
        desc: '진입 경로와 이동 방향을 시간 단위로 기록해 훈련 정확도를 정량 분석합니다.',
      },
      {
        icon: IconLayers, // 도면 기반 배치 → 공간적 설계 의미
        title: '설치도면 기반 정밀 배치',
        desc: '도면과 현장 사진을 기반으로 정확한 장비 배치와 운영 설계를 지원합니다.',
      },
      {
        icon: IconLayers, // 3D 맵 구현 → 공간적 구조 시각화
        title: '3D 디지털 맵 구현',
        desc: '훈련장의 실제 구조를 3D로 구현해 움직임을 실시간으로 시각화합니다.',
      },
      {
        icon: IconRoute, // 구조물 간섭 없는 수신 → 이동/위치 정확도 의미
        title: '구조물 간섭 없는 위치 수신',
        desc: '복잡한 구조물 내에서도 정확한 위치 수신이 가능하도록 설계되어 있습니다.',
      },
      {
        icon: IconCctvLine, // 통합 관제 → 실시간 위치 모니터링 의미
        title: '실시간 통합 관제',
        desc: '3D 디지털 맵 위에서 대원의 실시간 위치를 통합 확인하고 데이터를 분석합니다.',
      },
      {
        icon: IconAnalytics, // 훈련 평가 → 정량적 분석
        title: '데이터 기반 훈련 평가',
        desc: '이동 경로 데이터를 기준으로 훈련 목표 달성 여부를 정량적으로 평가합니다.',
      },
      {
        icon: IconSearch, // 설치 편의성 → 유연한 적용 의미
        title: '설치와 유지보수 편의',
        desc: '트래커는 구조물 조건에 맞춰 유연하게 설치되고 유지관리도 간편합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
